import { Table, TableCell, TableRow } from 'components/common/minimalTable'

/**
 * Interface for your Ecom Price document
 */
export interface EcomPrice {
  _id: string
  barcode: string
  cluster: string
  basePrice: string
  createdAt: string
  isImported: boolean
  specialPrice?: string
  specialPriceFromDate?: string
  specialPriceToDate?: string
  updatedAt: string
}

interface Props {
  priceList: EcomPrice[]
}

const EcomClusterPriceList = ({ priceList }: Props) => {
  return (
    <>
      <h3 className="title mt-3">Ecom Price List</h3>
      {priceList?.length > 0 && (
        <Table
          headers={[
            'Barcode',
            'Cluster',
            'Base Price',
            'Special Price',
            'Special Price From Date (DD/MM/YYYY)',
            'Special Price To Date (DD/MM/YYYY)',
          ]}
        >
          {priceList.map((price) => (
            <TableRow key={price._id}>
              <TableCell>{price.barcode}</TableCell>
              <TableCell>{price.cluster}</TableCell>
              <TableCell>{Number(price.basePrice).toFixed(2)}</TableCell>
              <TableCell>
                {price.specialPrice
                  ? Number(price.specialPrice).toFixed(2)
                  : '-'}
              </TableCell>
              <TableCell>
                {price.specialPriceFromDate
                  ? new Date(price.specialPriceFromDate).toLocaleDateString(
                      'en-GB',
                      {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      },
                    )
                  : '-'}
              </TableCell>
              <TableCell>
                {price.specialPriceToDate
                  ? new Date(price.specialPriceToDate).toLocaleDateString(
                      'en-GB',
                      {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      },
                    )
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      )}
    </>
  )
}

export default EcomClusterPriceList
